<template>
    <div :class="className">
        <slot name="before"></slot>
        <slot
            name="content"
            :icon="stateIcon"
            :label="stateLabel"
            :error="error"
        >
            <div
                class="w-full h-full flex flex-col justify-center items-center bg-white/80"
            >
                <div
                    class="w-12 h-12 bg-contain bg-center bg-no-repeat"
                    :style="'background-image: url(' + stateIcon + ')'"
                ></div>
                <template v-if="stateLabel">
                    <div
                        class="text-gray-500 text-center max-w-full px-3 pt-3 text-sm"
                    >
                        {{ stateLabel }}
                    </div>
                </template>
                <template v-if="error">
                    <div
                        class="text-red-500 text-center max-w-full px-3 pt-2 text-sm font-medium"
                    >
                        {{ error }}
                    </div>
                </template>
            </div>
        </slot>
        <slot name="afterContent"></slot>
        <slot name="beforeFile"></slot>
        <slot
            name="file"
            :fileClassName="fileClassName"
            :name="name"
            :accept="accept"
            :onSelectFile="onSelectFile"
        >
            <input
                type="file"
                :class="fileClassName"
                :name="!+disableFileToSend ? name : false"
                :accept="accept"
                ref="file"
                @change.prevent="onSelectFile"
            />
        </slot>
        <slot name="after"></slot>
    </div>
</template>

<script>
import mixinFile from "./mixinFile.vue";
import mixinCommon from "./mixinCommon.vue";

export default {
    name: "InputFile",
    mixins: [mixinFile, mixinCommon],
    props: {
        className: {
            type: String,
            default: "relative border rounded-2xl py-10 cursor-pointer",
        },
        fileClassName: {
            type: String,
            default: "absolute inset-0 w-full h-full opacity-0 cursor-pointer",
        },
        icon: {
            type: String,
            default: "",
        },
        iconLoaded: {
            type: String,
            default: "",
        },
        labelLoaded: {
            type: String,
            default: "",
        },

        error: {
            type: String,
            default: "",
        },

        onFileChange: {
            type: Function,
            default: () => {},
        },
    },
    computed: {
        stateLabel() {
            if (this.blob) {
                return (
                    this.blob.name ||
                    this.file.name ||
                    this.labelLoaded ||
                    this.label
                );
            }

            return this.label;
        },
        stateIcon() {
            if (!this.iconLoaded) {
                return this.icon;
            }
            return this.blob ? this.iconLoaded : this.icon;
        },
    },

    mounted() {},
    methods: {
        onSelectFile(evt) {
            this.file = !!+this.multiple
                ? evt.target.files
                : evt.target.files[0];
            this.onFileChange(evt);
        },
    },
};
</script>
